import React from "react";
import { Link } from "react-router-dom";
import { useSite } from "../../context/SiteContext";
import { Calavera } from "./Calavera";
const PETALS = Array.from({
  length: 16
}, (_, index) => index * 22.5);

/** Left side: the original Agave Family logo with the Blue Agave wordmark beside it. */
export function HeaderEmblem() {
  const {
    t
  } = useSite();
  return <Link to="/" aria-label={t("Blue Agave home", "Inicio de Blue Agave")} className="group flex min-w-0 items-center gap-2 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-marigold focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-73" data-mp="2mguir5rhz6wy">
      <img src="https://cdn.magicpatterns.com/uploads/6xvxXWGR6PhnV2LyYQmf5t/Agave-Family-Logo-Transparent.png" alt="" className="h-[52px] w-auto flex-none object-contain drop-shadow-[0_3px_4px_rgba(15,59,46,.2)] transition-transform duration-300 ease-out group-hover:scale-[1.04]" data-id="element-74" data-mp="27n7u6cpsnp6z" />
      <span className="flex min-w-0 flex-col leading-none" data-id="element-75" data-mp="2kkn7to7zhol">
        <span className="whitespace-nowrap font-serif text-[22px] font-bold tracking-tight text-agavedeep [text-shadow:0_1px_0_rgba(255,255,255,.8)] sm:text-[28px]" data-id="element-76" data-mp="2izt255ti0r9">
          Blue <span className="text-talavera" data-id="element-77" data-mp="3pq2519qqfrtd">Agave</span>
        </span>
        <span className="mt-1 flex items-center gap-1.5 whitespace-nowrap text-[9px] font-bold uppercase tracking-[.18em] text-chili sm:text-[10px]" data-id="element-78" data-mp="3tqc7wdj8a240">
          <span aria-hidden="true" className="h-1.5 w-1.5 rotate-45 bg-marigold" data-id="element-79" data-mp="lbc0v7f8pu8s" />
          Cocina Mexicana
        </span>
      </span>
    </Link>;
}

/** Right side: decorative cempasúchil + calavera badge. */
export function CalaveraBadge({
  className = ""
}: {
  className?: string;
}) {
  return <span aria-hidden="true" className={`group relative block flex-none drop-shadow-[0_4px_6px_rgba(15,59,46,.28)] ${className}`} data-id="element-80" data-mp="giivqifv0jw6">
      <svg viewBox="0 0 64 64" className="absolute inset-0 h-full w-full transition-transform duration-300 ease-out hover:rotate-[22deg]" data-id="element-81" data-mp="190d48g97uf77">
        <path d="M14 60C16 48 22 40 30 36C26 44 22 52 14 60Z" fill="#0F6B4A" data-id="element-82" data-mp="1ivbyurnauwtk" />
        <path d="M50 60C48 48 42 40 34 36C38 44 42 52 50 60Z" fill="#0F6B4A" data-id="element-83" data-mp="1eu8lqcwmzew1" />
        {PETALS.map((angle, index) => <ellipse key={angle} cx="32" cy="5.5" rx="4.6" ry="6.4" fill={index % 2 ? "#F2C230" : "#E8871E"} transform={`rotate(${angle} 32 32)`} data-id="element-84" data-mp="19um8i3gt5yn8" data-mpi={index} />)}
        {PETALS.map(angle => <ellipse key={`inner-${angle}`} cx="32" cy="10" rx="2.6" ry="4" fill="#C1272D" transform={`rotate(${angle + 11.25} 32 32)`} data-id="element-85" data-mp="v6izsmbds8uq" />)}
      </svg>
      <span className="absolute inset-[17%] rounded-full border-2 border-cream bg-talavera shadow-[inset_0_2px_4px_rgba(0,0,0,.35)]" data-id="element-86" data-mp="r331zmnks2gg" />
      <span className="absolute inset-[22%] rounded-full border border-dashed border-cream/50" data-id="element-87" data-mp="h7j9la87zlwg" />
      <Calavera className="absolute left-1/2 top-1/2 h-[46%] w-[38%] -translate-x-1/2 -translate-y-1/2" data-id="element-88" data-mp="c7eu9nj1sx7t" />
    </span>;
}